import React from 'react';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import {
  CheckBoxUnchecked,
  CheckBoxChecked,
} from 'AppSrc/core/components/common/svg-icons';
import PropTypes from 'prop-types';

const MyCRQFilterDisplayName = 'My CRQs only';

const CrqListMyCRQFilter = ({ isSelected, toggleMyCRQ }) => (
  <div className="crq-list-checkbox-filter crq-list-mycrq-filter">
    <h3>My CRQs</h3>
    <OptionButton
      className={`checkbox-option ${
        isSelected ? 'checkbox-option-selected' : ''
      }`}
      onClick={toggleMyCRQ}
      option={MyCRQFilterDisplayName}
    >
      <div className="svg-container">
        {isSelected ? <CheckBoxChecked /> : <CheckBoxUnchecked />}
      </div>
      {MyCRQFilterDisplayName}
    </OptionButton>
  </div>
);

CrqListMyCRQFilter.propTypes = {
  isSelected: PropTypes.bool,
  toggleMyCRQ: PropTypes.func,
};

export { CrqListMyCRQFilter, MyCRQFilterDisplayName };
